// extracted by mini-css-extract-plugin
module.exports = {"codeScreen":"_1So4Q-5aOPgYX8FdMdJEwm","logoWebLayout":"_2YZnenXicG963FoZC3NEOH"};